import { gql } from '@apollo/client';

export const GetCurrentSubscriptionInfo = gql`
    query getCurrentSubscriptionInfo {
        getCurrentSubscriptionInfo {
            success
            error
            subscription {
                planName
                features
                priceAmount
                nextBillingDate
                status
                cancelAtPeriodEnd
                nextBillingAmount
                trialEnd
            }
        }
    }
`;
